import React, { useState, useEffect } from 'react';
import { Settings as SettingsIcon, User, Bell, Lock, Database, Shield } from 'lucide-react';
import { userSecurity, auth } from '../services/api';

const Settings = () => {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState({
    notifications: {
      email: true,
      sms: false,
      app: true
    },
    security: {
      twoFactorEnabled: false,
      lastPasswordChange: null
    }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        console.log('Fetching user settings...');

        // Fetch current user
        const userResponse = await auth.getCurrentUser();
        console.log('User response:', userResponse);
        setUser(userResponse);

        // Fetch security settings
        const securityResponse = await userSecurity.getSettings();
        console.log('Security settings response:', securityResponse);
        setSettings(prevSettings => ({
          ...prevSettings,
          security: securityResponse.data
        }));

      } catch (error) {
        console.error('Error fetching settings:', error);
        console.error('Error details:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status
        });
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleSaveSettings = async (newSettings) => {
    try {
      await userSecurity.updateSettings(newSettings);
      setSettings(newSettings);
    } catch (error) {
      console.error('Error saving settings:', error);
    }
  };

  if (loading) {
    return <div className="p-6">Loading settings...</div>;
  }

  return (
    <div className="p-6">
      <div className="flex items-center mb-6">
        <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 mr-3">
          <SettingsIcon size={20} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
          <p className="text-gray-600">Manage your account and preferences</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Profile Settings */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center mb-4">
            <User size={20} className="text-brand-600 mr-2" />
            <h2 className="text-lg font-medium text-gray-900">Profile Settings</h2>
          </div>
          <p className="text-sm text-gray-600 mb-4">Update your personal information and preferences</p>
          <button className="text-sm text-brand-600 hover:text-brand-900">
            Edit Profile
          </button>
        </div>

        {/* Notifications */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center mb-4">
            <Bell size={20} className="text-brand-600 mr-2" />
            <h2 className="text-lg font-medium text-gray-900">Notifications</h2>
          </div>
          <p className="text-sm text-gray-600 mb-4">Configure your notification preferences</p>
          <button className="text-sm text-brand-600 hover:text-brand-900">
            Manage Notifications
          </button>
        </div>

        {/* Security */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center mb-4">
            <Lock size={20} className="text-brand-600 mr-2" />
            <h2 className="text-lg font-medium text-gray-900">Security</h2>
          </div>
          <p className="text-sm text-gray-600 mb-4">Manage your password and security settings</p>
          <button className="text-sm text-brand-600 hover:text-brand-900">
            Security Settings
          </button>
        </div>

        {/* Data Management */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center mb-4">
            <Database size={20} className="text-brand-600 mr-2" />
            <h2 className="text-lg font-medium text-gray-900">Data Management</h2>
          </div>
          <p className="text-sm text-gray-600 mb-4">Manage your data and privacy settings</p>
          <button className="text-sm text-brand-600 hover:text-brand-900">
            Data Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings; 